// src/theme/irene.js
import { createTheme } from "@mui/material/styles";

export const ireneTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#1ABC9C" },
    secondary: { main: "#F39C12" },
    background: { default: "#111315", paper: "#1a1d20" },
  },
  typography: {
    fontFamily: `"Inter","Noto Sans JP",sans-serif`,
  },
});
